import { buildClasses } from "../utils/buildClasses";
import { getTagColor } from "./tagColors";

export function TagDot({
  colorId,
  size = "md",
}: {
  colorId: string | undefined;
  size?: "sm" | "md" | "lg";
}): JSX.Element {
  const color = getTagColor(colorId);
  return (
    <span
      className={buildClasses(
        "inline-block",
        "rounded-full",
        "flex-shrink-0",
        {
          switch: size,
          cases: new Map([
            ["sm", "w-2 h-2"],
            ["md", "w-2.5 h-2.5"],
            ["lg", "w-3 h-3"],
          ]),
        },
      )}
      style={{ backgroundColor: color.dot }}
    />
  );
}
